import React from 'react';
import Box from '@mui/material/Box';
import {
    Outlet,
} from "react-router-dom";

// currently does nothing other than being used as the top-level element in the main route
export default function Root(props) {
    return (
        <Box className="Root">
            <Outlet />
        </Box>
    );
};

